<script setup>

import InlineSvg from "vue-inline-svg";
import {computed, onMounted, ref} from "vue";

const props = defineProps({
	icons: Array,
});


let copyElement = ref('');
const copyNotificationVisible = ref(false);

document.addEventListener('copy', function(e){

	// only intercept if we're trying to copy something
	if(copyElement.value !== '') {

		// pull out the actual content we want from the json
		let element = copyElement.value['clipboard']['gslides'];

		// loop through it and add to the clipboard for each one
		for(const type in element) {
			e.clipboardData.setData(type, element[type]);
		}
		console.log("added!");

		e.preventDefault(); // default behaviour is to copy any selected text

		copyNotificationVisible.value = true;
		setTimeout(() => copyNotificationVisible.value = false, 10000)

		// now clear the copyElement so we're ready for the next copy
		copyElement.value = '';

	}
});
function copyToClipboard(icon) {
	console.log(icon);
	copyElement.value = icon;
	document.execCommand("copy");
}

///

// Duplicate the icons array to create a seamless loop
// const duplicatedIcons = computed(() => [...props.icons, ...props.icons]);
//
// // Reference to the scrolling content
// const scrollingContent = ref(null);
//
// onMounted(() => {
// 	const content = scrollingContent.value;
// 	if (content) {
// 		// Calculate the total width of the scrolling content
// 		const totalWidth = content.scrollWidth / 2; // Since we duplicated the icons
//
// 		// Dynamically set the animation duration based on the content width
// 		content.style.animationDuration = `${totalWidth / 20}s`;
// 	}
// });

</script>

<template>

	<div class="relative">

		<div aria-live="assertive" class="z-50 absolute inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start">
			<div class="w-full flex flex-col items-center space-y-4 sm:items-end">
				<transition v-show="copyNotificationVisible" enter-active-class="transform ease-out duration-300 transition" enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2" enter-to-class="translate-y-0 opacity-100 sm:translate-x-0" leave-active-class="transition ease-in duration-100" leave-from-class="opacity-100" leave-to-class="opacity-0">
					<div class="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden">
						<div class="p-4">
							<div class="flex items-start">
								<div class="ml-3 w-0 flex-1 pt-0.5 mb-4">

									<!-- Desktop/tablet content (sm and above) -->
									<div class="hidden sm:block">
										<p class="text-gray-900 font-funnel text-lg">Copied!</p>
										<p class="text-sm text-gray-500 inline-flex">1 - Find a
											<span class="mx-1">
												<svg class="size-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 256 256">
													<path fill="#F4B400" d="M0 30C0 13.431 13.431 0 30 0h196c16.569 0 30 13.431 30 30v196c0 16.569-13.431 30-30 30H30c-16.569 0-30-13.431-30-30V30Z"/>
													<path fill="#fff" d="M28 71h200v114H28V71Z"/>
												</svg>
											</span>
											 presentation,
											<a target="_blank" rel="noopener noreferrer" href="https://slides.new" class="inline-flex hover:underline group">
												<span class="flex ml-1">
													or open a new one
													<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" class="size-[0.8rem] group-hover:translate-x-px group-hover:-translate-y-px transition-transform transform ease-out duration-300 transition">
														<path fill-rule="evenodd" d="M4.22 11.78a.75.75 0 0 1 0-1.06L9.44 5.5H5.75a.75.75 0 0 1 0-1.5h5.5a.75.75 0 0 1 .75.75v5.5a.75.75 0 0 1-1.5 0V6.56l-5.22 5.22a.75.75 0 0 1-1.06 0Z" clip-rule="evenodd"/>
													</svg>
												</span>
											</a>
										</p>
										<p class="text-sm text-gray-500">2 - Use <span class="font-mono text-gray-800">Ctrl + V</span> to paste; edit as needed</p>
									</div>

									<!-- Mobile content (below sm breakpoint) -->
									<div class="block sm:hidden">
										<div class="flex -ml-1.5 pb-4 items-center space-x-1">
											<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
												<path stroke-linecap="round" stroke-linejoin="round" d="M10.5 1.5H8.25A2.25 2.25 0 0 0 6 3.75v16.5a2.25 2.25 0 0 0 2.25 2.25h7.5A2.25 2.25 0 0 0 18 20.25V3.75a2.25 2.25 0 0 0-2.25-2.25H13.5m-3 0V3h3V1.5m-3 0h3m-3 18.75h3" />
											</svg>
											<p class="text-gray-900 font-funnel text-lg">Nice phone!</p>
										</div>
										<p class="text-sm text-gray-500">This works best on desktop; copied icons go straight to your clipboard for easy pasting into Slides.</p>
										<br>
										<p class="text-sm text-gray-500">Come back on desktop and try it out!</p>
									</div>

								</div>

							</div>
						</div>
					</div>
				</transition>
			</div>
		</div>

<!--		<div class="relative w-[80%] mx-auto overflow-hidden group text-gray-600 hover:text-gray-900">-->
<!--			&lt;!&ndash; Scrolling Icons &ndash;&gt;-->

<!--			<div ref="scrollingContent" class="inline-flex animate-scroll text-gray-300 ">-->
<!--				<div v-for="(icon, index) in duplicatedIcons" :key="index" class="mx-2 shrink-0 text-gray-300">-->
<!--					<inline-svg :src="'../images/icons/' + icon.collection + '/' + icon.short_name + '.svg'" class="size-6 text-gray-300 stroke-current"></inline-svg>-->
<!--				</div>-->
<!--			</div>-->

<!--			&lt;!&ndash; Fade Effect &ndash;&gt;-->
<!--			<div class="absolute inset-y-0 left-0 w-10 bg-gradient-to-r from-white to-transparent"></div>-->
<!--			<div class="absolute inset-y-0 right-0 w-10 bg-gradient-to-l from-white to-transparent"></div>-->
<!--		</div>-->

		<ul role="list" class="grid grid-cols-4 gap-4 p-8">


			<li v-for="(icon,index) in icons" :key="icon.id"
				@click="copyToClipboard(icon)"
				class="relative flex flex-col-reverse group"
				data-heap="select-icon-homescreen"
			>
				<div type="button" :id="icon.short_name" :aria-label="icon.short_name"
					 :aria-controls="icon.short_name"
					 class="h-16 w-16 flex items-center justify-center rounded-lg  group-hover:bg-gray-100 cursor-pointer">

					<img :src="icon.url" class="w-6 h-6 text-gray-500 group-hover:text-gray-600" alt="icon" />
<!--					<inline-svg :src="'../images/icons/'  + icon.collection +'/'+ icon.short_name + '.svg'" class="w-6 h-6 "></inline-svg>-->

				</div>
			</li>
		</ul>
	</div>
</template>

<style scoped>
/* Define the scroll animation */
@keyframes scroll {
	0% {
		transform: translateX(0);
	}
	100% {
		transform: translateX(-50%); /* Move by half the width of the duplicated content */
	}
}

/* Apply the animation to the scrolling content */
.animate-scroll {
	animation: scroll linear infinite;
}
</style>